import HighlightBlankLayout from './layout';

export default HighlightBlankLayout;
